module.exports = __webpack_public_path__ + "static/media/flag_chn.1e69ea8c.png";